import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
import { AutocompleteOption } from '../autocomplete/autocomplete.component';
import { RefusalReasonService } from 'src/app/services/refusal-reason.service';
import {
  Reason,
  ReasonMessageType,
} from 'src/app/shared/model/refusal-reasons.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-autocomplete-form-reason',
  templateUrl: './autocomplete-form-reason.component.html',
  styleUrl: './autocomplete-form-reason.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteFormReasonComponent),
      multi: true,
    },
  ],
})
export class AutocompleteFormReasonComponent
  implements ControlValueAccessor, OnInit
{
  @Input() reasonIds!: Observable<number[]>;
  @Input() type: ReasonMessageType = 'refusal';

  value: AutocompleteOption | null = null;
  options: AutocompleteOption[] = [];
  disabled = false;
  control!: NgControl;

  constructor(
    private refusalReasonService: RefusalReasonService,
    private injector: Injector
  ) {}

  get isError() {
    return this.control.touched && this.control?.errors !== null;
  }

  get errorMessage() {
    return this.isError ? 'Preencha o campo' : null;
  }

  ngOnInit() {
    this.setReasons();
    this.control = this.injector.get(NgControl);
  }

  setReasons() {
    if (this.type === 'refusal')
      this.reasonIds.subscribe((reasonIds) => {
        this.refusalReasonService
          .getList({ type: this.type, reasonIds })
          .subscribe({
            next: (reasons) => this.handleSubscribeSuccess(reasons),
            error: () => (this.options = []),
          });
      });
    else
      this.refusalReasonService.getList({ type: this.type }).subscribe({
        next: (reasons) => this.handleSubscribeSuccess(reasons),
        error: () => (this.options = []),
      });
  }

  handleSubscribeSuccess(reasons: Reason[]) {
    reasons.sort((a, b) => a.title.localeCompare(b.title));
    this.options = (
      [
        {
          value: 'new',
          name: 'Mensagem personalizada',
          description: '',
        },
      ] as AutocompleteOption[]
    ).concat(reasons.map((reason) => this.formatOption(reason)));
  }

  formatOption(reason: Reason) {
    return {
      name: reason.title,
      value: reason.id,
      description: reason.description,
      data: { reason },
    };
  }

  handleOptionSelected(selectedOption: AutocompleteOption) {
    this.value = selectedOption;

    this.onChange(this.value?.data?.reason ?? null);
    this.onTouched();
  }

  writeValue(value: Reason): void {
    this.value = !!value ? this.formatOption(value) : null;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // eslint-disable-next-line
  private onChange = (val: Reason | null) => {};
  private onTouched = () => {};
}
